module.exports = __webpack_public_path__ + "img/logo.9ae7b65b.png";